import { BaseClient } from './BaseClient'

export class ProfileApi extends BaseClient {
  getProfileHistoryFilters = this.createRequest({
    url: '/api/user/history/filters',
    method: 'get',
  })
  getProfileRefferals = this.createRequest({
    url: '/api/user/history/filters',
    method: 'get',
  })
  changeProfilePassword = this.createRequest({
    url: '/api/user/change-password',
    method: 'post',
  })
  getSessions = this.createRequest({
    url: '/api/user/sessions',
    method: 'get',
  })
  deleteSession = this.createRequest({
    url: '/api/user/sessions',
    method: 'delete',
  })

  getProfileHistory = (payload) => {
    return this.createRequest({
      url: `/api/user/history`,
      method: 'get',
    })(payload)
  }
}
